var $ = require('jquery');

$(function () {
    var $images = $('.ws-circular-image__image');
    
    $images.each(function() {
        if (this.complete) {
            determineImageOrientation(this);
        } else {
            this.addEventListener('load', imageLoaded);
        }
    });

    function imageLoaded() {
        determineImageOrientation(this);
    }

    function determineImageOrientation(image) {
        if (image.naturalWidth > image.naturalHeight) {
            $(image).addClass('ws-circular-image__image--orientation_landscape');
        }
    }
});